module.exports = [
  {
    display: '👍',
    message: 'Looks good to me 👍',
  },
  {
    display: '❓',
    message: 'Does everyone agree❓',
  },
  {
    display: '⏸',
    message: 'I need a minute to catch up, please! ⏸ ',
  },
  {
    display: '💭',
    message: 'Could you please explain your thoughts? 💭',
  },
  {
    display: '💡',
    message: '...I have an idea! 💡 ',
  },
  {
    display: '🛑',
    message: 'No 🛑 ',
  },
  {
    display: '🤔',
    message: "Hmm, I'm not sure I agree 🤔 ",
  },
  {
    display: '➡️',
    message: 'Ready to move on? ➡️',
  },
  {
    display: '🚌',
    message: 'Who wants to drive? 🚌 ',
  },
  {
    display: '🎯',
    message: 'Nailed it! 🎯 ',
  },
  {
    display: '👏',
    message: 'Great work, Team! 👏 👏',
  },
];



// WEBPACK FOOTER //
// ./src/Components/Chat/QuickChatList.js